import axios from "axios";
import { createAuthenticatedAxiosInstance } from "../auth/auth.slice";

const baseUrl = import.meta.env.VITE_API_URL;

export const businessService = {
    // Get business details
    getBusiness: async () => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.get(baseUrl + "business");
        return response.data;
    },

    // Update business details
    updateBusiness: async (data) => {
        const axiosInstance = createAuthenticatedAxiosInstance();
        const response = await axiosInstance.put(baseUrl + "business", data);
        return response.data;
    },
};
